import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";

/**
 * Publiczna część RFQ — jedyne zapytania modułu, które lecą BEZ LOGOWANIA.
 *
 * Osobny plik od `proceedings.ts` celowo: te trzy adresy są dostępne dla całego
 * świata, więc mają być widoczne na pierwszy rzut oka i nie mieszać się z resztą,
 * która wymaga konta. Payload jest najwęższy w module — patrz backend
 * `PublicProceedingSerializer`.
 */

export interface PublicListing {
  id: string;
  number: string;
  title: string;
  description: string;
  submission_deadline: string;
  delivery_deadline: string | null;
  max_price_net: string | null;
  price_basis: string;
  voivodeship: string;
  voivodeship_label: string;
  county_labels: string[];
  positions_detail: { id: string; name: string; category_name: string }[];
  published_at: string | null;
  is_open_for_offers: boolean;
  /* Sam obrys zakresu MDCP (GeoJSON 4326) — bez punktów zdjęciowych, te zostają za
     logowaniem. null dla postępowań spoza MDCP. */
  mdcp_outline: object | null;
}

export function usePublicProceedings() {
  return useQuery({
    queryKey: ["rfq", "public", "list"],
    queryFn: () =>
      apiClient
        .get<{ data: PublicListing[] }>("/rfq/public/proceedings/")
        .then((r) => r.data.data),
  });
}

export function usePublicProceeding(id: string | undefined) {
  return useQuery({
    queryKey: ["rfq", "public", id],
    enabled: !!id,
    queryFn: () =>
      apiClient
        .get<{ data: PublicListing }>(`/rfq/public/proceedings/${id}/`)
        .then((r) => r.data.data),
  });
}

export interface AccountRequestPayload {
  company_name: string;
  nip: string;
  contact_person: string;
  email: string;
  phone: string;
  message: string;
  proceeding?: string;
  consent: boolean;
  /** Pułapka na boty — pole ukryte w formularzu, człowiek go nie wypełni. */
  website: string;
}

export function useSubmitAccountRequest() {
  return useMutation({
    mutationFn: (payload: AccountRequestPayload) =>
      apiClient.post("/rfq/public/account-request/", payload),
  });
}
